import { render, staticRenderFns } from "./ArticleSource.vue?vue&type=template&id=afb723a8&scoped=true"
import script from "./ArticleSource.vue?vue&type=script&lang=js"
export * from "./ArticleSource.vue?vue&type=script&lang=js"
import style0 from "./ArticleSource.vue?vue&type=style&index=0&id=afb723a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afb723a8",
  null
  
)

export default component.exports